import React, { useState, useRef, useEffect } from 'react';

import { useDetectOutsideClick } from 'hooks/useDetectOutsideClick';
import {
  CustomSorterWrapper,
  CaretIcon,
  DropDownListContainer,
  DropDownList,
  ListItem,
  LabelAndIconContainer,
  IconContainer,
} from './styles';

export default function CustomSorter({ value, descendingOrder, options = [], onChange, showLabel }) {
  const dropdownRef = useRef(null);

  const [selectedOption, setSelectedOption] = useState(options?.find((option) => option.value === value)?.label);
  const [isOpenDropdown, setIsOpenDropdown] = useDetectOutsideClick(dropdownRef, false);

  useEffect(() => {
    setSelectedOption(options?.find((option) => option.value === value)?.label);
  }, [value, options]);

  return (
    <CustomSorterWrapper
      ref={dropdownRef}
      onClick={() => {
        setIsOpenDropdown(!isOpenDropdown);
      }}
    >
      <LabelAndIconContainer>
        {showLabel}
        {selectedOption}
        <IconContainer>
          <CaretIcon isOpen={isOpenDropdown} icon="fa-solid fa-chevron-down" />
        </IconContainer>
      </LabelAndIconContainer>
      {isOpenDropdown && (
        <DropDownListContainer>
          <DropDownList>
            {options.map((option) => (
              <ListItem
                key={option.label}
                onClick={() => {
                  setSelectedOption(option.label);
                  onChange({
                    value: option.value,
                    descendingOrder,
                  });
                  setIsOpenDropdown(false);
                }}
              >
                {option.label}
              </ListItem>
            ))}
          </DropDownList>
        </DropDownListContainer>
      )}
    </CustomSorterWrapper>
  );
}
